import type {
  GetAppointmentListPayload,
  GetAppointmentLists,
} from '@shared/services/appointment/getLists/types/getAppointmentList.type';
import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_APPOINTMENTS_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import { groupAppointmentsByLinkId } from '@features/Appointment/utils/tools';

export const TAG_APPOINTMENT_LIST = 'getAppointmentList';

export const getAppointmentList = <T extends BuilderType>(builder: T) =>
  builder.query<GetAppointmentLists, GetAppointmentListPayload | null>({
    providesTags: [TAG_APPOINTMENT_LIST],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_APPOINTMENTS_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetAppointmentLists>) => {
      if (hasCcdpSuccess(response)) {
        const { MissedAppointments, MoreInformation, OpenAppointments, UpcomingAppointments } = response.Result;
        return {
          MissedAppointments: groupAppointmentsByLinkId(MissedAppointments),
          MoreInformation,
          OpenAppointments: groupAppointmentsByLinkId(OpenAppointments),
          UpcomingAppointments: groupAppointmentsByLinkId(UpcomingAppointments),
        };
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
